var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(_vm.$msal.isAuthenticated())?_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"sidenav"},[_c('Menu')],1)]):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }